/* lyd-preorder-dedupe: single preorder ship message (Premium Set + Akku Standard Weiss) */
(function () {
  function pathOk(path) {
    return (
      path.indexOf("/products/lynden-premium-set") !== -1 ||
      path.indexOf("/products/lynden-akku-standard") !== -1
    );
  }

  function isAkku(path) {
    return path.indexOf("/products/lynden-akku-standard") !== -1;
  }

  function hideDupOffers() {
    document.querySelectorAll(".product-info .offer, .offer.bg-custom").forEach(function (el) {
      var t = (el.textContent || "").toLowerCase();
      if (
        t.indexOf("vorbestellung") !== -1 ||
        t.indexOf("31. juli") !== -1 ||
        t.indexOf("vorbestellen") !== -1
      ) {
        el.style.setProperty("display", "none", "important");
      }
    });
  }

  function ensureBanner(path) {
    var existing = document.querySelector(".lyd-preorder-ship");
    var titleText = "Vorbestellung · Garantierter Versand ab 31. Juli 2026";
    var subText = isAkku(path)
      ? "Farbe Weiß wieder lieferbar ab Versandtermin · Zahlung bei Bestellung · Schwarz ggf. separat verfügbar"
      : "Zahlung bei Bestellung · Versand sobald die neuen Akkus (Standard Weiß) eintreffen · Sorten: Original Tabak, Tabak No. 2, Fresh Menthol (6/12/18 mg)";

    if (!existing) {
      var wrap = document.createElement("div");
      wrap.className = "lyd-preorder-ship";
      wrap.setAttribute("role", "status");
      wrap.setAttribute("data-lyd-rev", "preorder-akku-weiss");
      wrap.style.cssText =
        "border:1px solid rgba(11,61,92,.18);background:#eef6ff;color:#0b3d5c;border-radius:8px;padding:.7rem .85rem;line-height:1.35;margin:0 0 .65rem";
      wrap.innerHTML =
        '<div class="lyd-preorder-ship__title" style="font-weight:700;font-size:.92rem">' +
        titleText +
        "</div>" +
        '<div class="lyd-preorder-ship__sub" style="margin-top:.2rem;font-size:.82rem;opacity:.92">' +
        subText +
        "</div>";

      var slot = document.getElementById("lyd-delivery-timer-slot");
      var table = document.getElementById("lyd-variant-table");
      var buy = document.querySelector(".buy-buttons, product-form, .product-info__buy-buttons");
      var info = document.querySelector(".product-info");

      if (slot) {
        slot.innerHTML = "";
        slot.appendChild(wrap);
        slot.style.display = "";
      } else if (table && table.parentNode) {
        table.parentNode.insertBefore(wrap, table);
      } else if (buy && buy.parentNode) {
        buy.parentNode.insertBefore(wrap, buy);
      } else if (info) {
        info.insertBefore(wrap, info.firstChild);
      }
    } else {
      var title = existing.querySelector(".lyd-preorder-ship__title") || existing.firstElementChild;
      var sub = existing.querySelector(".lyd-preorder-ship__sub");
      if (title) title.textContent = titleText;
      if (sub) sub.textContent = subText;
    }
  }

  function run() {
    try {
      var path = location.pathname || "";
      if (!pathOk(path)) return;
      hideDupOffers();
      ensureBanner(path);
    } catch (e) {}
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  setTimeout(run, 400);
  setTimeout(run, 1500);
})();

/* === OG PDP unhide inject === */
/**
 * Impact live compat — relocate + unhide ALL HV2 product body blocks
 * (id^=lyd-pdp). Bodies hide themselves inside .product-info until detached.
 */
(function () {
  function show(block) {
    if (!block) return;
    block.classList.add("lyd-pdp--detached");
    var styles = {
      position: "static",
      width: "100%",
      height: "auto",
      maxWidth: "1344px",
      overflow: "visible",
      clip: "auto",
      clipPath: "none",
      display: "block",
      whiteSpace: "normal",
      margin: "0.75rem auto 2.5rem",
      padding: window.matchMedia("(max-width: 999px)").matches ? "0 16px" : "0 48px",
    };
    Object.keys(styles).forEach(function (k) {
      block.style.setProperty(
        k.replace(/[A-Z]/g, function (m) {
          return "-" + m.toLowerCase();
        }),
        styles[k],
        "important"
      );
    });
    // also force common camelCase props
    block.style.setProperty("position", "static", "important");
    block.style.setProperty("width", "100%", "important");
    block.style.setProperty("height", "auto", "important");
    block.style.setProperty("overflow", "visible", "important");
    block.style.setProperty("display", "block", "important");
    block.style.setProperty("clip", "auto", "important");
    block.style.setProperty("clip-path", "none", "important");
  }

  function findBlocks() {
    return Array.prototype.slice.call(document.querySelectorAll("[id^='lyd-pdp']"));
  }

  function relocateOne(block) {
    if (!block) return;
    show(block);
    if (block.dataset.relocated === "1") return;

    var product =
      document.querySelector(".shopify-section--main-product .product") ||
      document.querySelector(".product") ||
      document.querySelector("[data-product-id]") ||
      document.querySelector(".shopify-section--main-product");

    // Prefer place after entire product section
    var section =
      document.querySelector(".shopify-section--main-product") ||
      (product && product.closest(".shopify-section"));

    if (section && section.parentNode) {
      // if still nested inside product-info / buybox, move below section
      if (section.contains(block) && block.closest(".product-info, .product-content, .product")) {
        section.parentNode.insertBefore(block, section.nextSibling);
        block.dataset.relocated = "1";
        show(block);
        return;
      }
    }

    if (product && product.contains(block) && product.parentNode) {
      product.parentNode.insertBefore(block, product.nextSibling);
      block.dataset.relocated = "1";
      show(block);
    }
  }

  function relocateAll() {
    findBlocks().forEach(relocateOne);
  }

  /** G4-only accessory note (kept from previous live fix) */
  function injectPods() {
    try {
      if ((location.pathname || "").indexOf("uwell-caliburn-g4-pod-e-zigarette") === -1) return;
      if (document.querySelector(".lyd-buybox-pods")) return;
      var host =
        document.querySelector(".product-info__buy-buttons") ||
        document.querySelector("[data-product-form]") ||
        document.querySelector("form[action*='/cart/add']");
      if (!host || !host.parentNode) return;
      var el = document.createElement("div");
      el.className = "lyd-buybox-pods";
      el.innerHTML =
        'Passend dazu: <a href="/products/uwell-caliburn-g4-pod-3-stuck-pro-packung">G4 Pods (3er-Pack) ab 11,95&nbsp;€</a> — häufiger Nachkauf zum Gerät.';
      host.parentNode.insertBefore(el, host.nextSibling);
    } catch (e) {}
  }

  function boot() {
    relocateAll();
    injectPods();
    var n = 0;
    var iv = setInterval(function () {
      n++;
      relocateAll();
      injectPods();
      if (n > 30) clearInterval(iv);
    }, 200);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();

